import { render } from "./AboutUs.vue?vue&type=template&id=0fcd8a04&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0fcd8a04"

export default script